import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=09ccf524&"
import script from "./ContactForm.vue?vue&type=script&lang=ts&"
export * from "./ContactForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ccf524')) {
      api.createRecord('09ccf524', component.options)
    } else {
      api.reload('09ccf524', component.options)
    }
    module.hot.accept("./ContactForm.vue?vue&type=template&id=09ccf524&", function () {
      api.rerender('09ccf524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/ContactForm.vue"
export default component.exports